import Vue from 'vue'
import Vuex from 'vuex'
import AdService from '@/services/AdService.js'
import UserService from '@/services/UserService.js'
import axios from 'axios'
import apiClient from '@/services/API'
import router from './router'
// import imagePreloader from 'vue-image-preloader'
// Vue.use(imagePreloader)
// import prefetchImages from 'prefetch-image'
import Preload from 'image-preload'
import * as Sentry from '@sentry/browser'
import storage from '@/utils/storage'
import posthog from 'posthog-js'
import swaps from '@/store/swaps'

Vue.use(Vuex)

// Shared promise for the initial session bootstrap (getMe + getMyAds), so
// route guards on a direct page load can wait for it instead of reading the
// empty initial state.
let sessionReady = null

export default new Vuex.Store({
  modules: {
    swaps
  },
  state: {
    referer: '',
    user: false,
    categories: ['Hyresrätt', 'Bostadsrätt'],
    rooms: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    showFilters: false,
    prospects: [],
    prospectsLoading: false,
    prospectsPhotos: [],
    myAds: [],
    // Number of page-level loads holding the full-screen preloader (see holdPreloader).
    pageLoads: 0,
    listenToKeyboard: false,
    prospectModal: false,
    adDetails: false,
    loginstatus: '',
    apiBase:
      storage.getItem('apiBase') || 'https://api.bytbostad.se/api/v1',
    token: false,
    filters: false,
    filtersLoading: false,
    locations: [],
    fbSdkReady: false,
    fbConnected: false,
    fbFirstName: '',
    matches: [],
    history: [],
    memberships: [],
    outOfMatches: false,
    showMoreMenu: false,
    frontPage: [],
  geojsons: {},
  geojsonsLoading: false,
  geojsonsError: null
  },
  mutations: {
    SET_FILTER_LOCATION_IDS(state, locationIds) {
    state.filters.locationIds = locationIds;
  },
    SET_GEOJSONS(state, features) {
    const newGeoJsons = {};
    features.forEach(feature => {
      if (feature.properties && feature.properties.bb_id) {
        newGeoJsons[feature.properties.bb_id] = feature;
      }
    });
    
    state.geojsons = {
      ...state.geojsons,
      ...newGeoJsons
    };
  },
  
  SET_GEOJSONS_LOADING(state, loading) {
    state.geojsonsLoading = loading;
  },
  
  SET_GEOJSONS_ERROR(state, error) {
    state.geojsonsError = error;
  },
  
  CLEAR_GEOJSONS_ERROR(state) {
    state.geojsonsError = null;
  },
    REMOVE_PROSPECT (state, id) {
      // state.prospects.shift()
      // console.log(state.prospects)
      const newProspects = state.prospects.filter(
        prospect => prospect.id !== id
      )
      // console.log(newProspects)
      state.prospects = newProspects
    },
    // REMOVE_PROSPECT(state) {
    //   state.prospects.shift()
    // },
    AUTH_LOGOUT (state) {
      storage.removeItem('token')
      storage.removeItem('me')
      state.loginstatus = ''
      state.token = false
      state.prospects = []
      state.user = false
      state.filters = false
      state.myAds = []
      state.matches = []
      state.history = []
      state.memberships = []
    },
    AUTH_REQUEST (state) {
      state.loginstatus = 'loading'
    },
    AUTH_ERROR (state) {
      state.loginstatus = 'error'
      state.token = false
    },
    AUTH_SUCCESS (state, token) {
      state.loginstatus = 'success'
      state.token = token
    },
    SET_USER (state, user) {
      state.user = user
    },
    SET_REFERER (state, referer) {
      state.referer = referer
    },
    OUT_OF_MATCHES (state, outOfMatches) {
      state.outOfMatches = outOfMatches
    },
    SET_MEMBERSHIPS (state, memberships) {
      state.memberships = memberships
    },
    SET_MATCHES (state, matches) {
      state.matches = matches
    },
    SET_FRONTPAGE (state, items) {
      state.frontPage = items
    },
    SET_HISTORY (state, history) {
      state.history = history
    },
    SET_AD_DETAILS (state, ad) {
      state.adDetails = ad
    },
    SET_PROSPECTS_LOADING (state, value) {
      state.prospectsLoading = value
    },
    PAGE_LOAD_START (state) {
      state.pageLoads++
    },
    PAGE_LOAD_END (state) {
      state.pageLoads = Math.max(0, state.pageLoads - 1)
    },
    SET_PROSPECT_MODAL (state, value) {
      // console.log('Setting prospect modal to ', value)
      state.prospectModal = value
    },
    // SET_PROSPECT_PHOTOS(state, value) {
    //   state.prospectsLoading = value
    // },
    SET_LOCATIONS (state, locations) {
      state.locations = locations
    },
    SET_FILTERS (state, filters) {
      state.filters = filters
    },
    SET_FILTERS_LOADING (state, loading) {
      state.filtersLoading = loading
    },
    LISTEN_TO_KEYBOARD (state, value) {
      state.listenToKeyboard = value
    },
    SET_MORE_MENU (state, value) {
      state.showMoreMenu = value
    },
    TOGGLE_MORE_MENU (state) {
      state.showMoreMenu = !state.showMoreMenu
    },
    TOGGLE_FILTERS (state) {
      state.showFilters = !state.showFilters
    },
    SET_TOGGLE_FILTERS (state, value) {
      state.showFilters = value
    },
    SET_PROSPECTS (state, prospects) {
      state.prospects = prospects
    },
    APPEND_PROSPECTS (state, prospects) {
  // Get existing prospect IDs for quick lookup
  const existingIds = new Set(state.prospects.map(p => p.id))
  
  // Filter out prospects that already exist
  const newProspects = prospects.filter(p => !existingIds.has(p.id))
  
  // Append new prospects to the end of the array
  state.prospects = [...state.prospects, ...newProspects]
  },
    SET_API (state, apiBase) {
      storage.setItem('apiBase', apiBase)
      state.apiBase = apiBase
    },
    SET_MY_ADS (state, myAds) {
      state.myAds = myAds
    },
    SET_FB_SDK (state, sdk) {
      state.fbSdkReady = sdk
    },
    SET_FB_CONNETED (state, value) {
      state.fbConnected = value
    },
    SET_FB_REFUSED (state, value) {
      state.fbRefused = value
    },
    SET_FB_FIRSTNAME (state, value) {
      state.fbFirstName = value
    }
  },
  actions: {

    
    async fetchGeoJson({ commit, state }, ids) {
    try {
      commit('CLEAR_GEOJSONS_ERROR');
      
      const requestedIds = Array.isArray(ids) 
        ? ids 
        : ids.toString().split(',').map(id => parseInt(id.trim()));
      
      const missingIds = requestedIds.filter(id => !state.geojsons[id]);
      
      if (missingIds.length === 0) {
        return requestedIds.map(id => state.geojsons[id]);
      }
      
      commit('SET_GEOJSONS_LOADING', true);
      
      const idsToFetch = missingIds.length === 1 
        ? missingIds[0] 
        : missingIds.join(',');
      
      const response = await UserService.getGeoJson(idsToFetch);
      
      if (response.data && response.data.type === 'FeatureCollection') {
        commit('SET_GEOJSONS', response.data.features);
      }
      
      commit('SET_GEOJSONS_LOADING', false);
      
      return requestedIds.map(id => state.geojsons[id]).filter(Boolean);
      
    } catch (error) {
      commit('SET_GEOJSONS_ERROR', error);
      commit('SET_GEOJSONS_LOADING', false);
      throw error;
    }
  },



    myAction (context, { vm }) {
      vm.$notify()
    },
    preLoadImages ({ commit }, images) {
      if (!images || !images.length) {
        commit('SET_PROSPECTS_LOADING', false)
        return Promise.resolve()
      }
      // commit('SET_PROSPECTS_LOADING', true)
      return new Promise((resolve, reject) => {
        Preload(images.filter(Boolean).slice(0, 3), {
          inBackground: false,
          toBase64: false,
          // onSingleImageComplete: res => console.log(res.path[0].currentSrc),
          onComplete: () => resolve(commit('SET_PROSPECTS_LOADING', false))
        })
      })
    },
    likeProspect ({ commit }, id) {
      return new Promise((resolve, reject) => {
        // console.log(id)
        resolve()
      })
    },
    getMemberships ({ commit }) {
      return new Promise((resolve, reject) => {
        UserService.getMemberships()
          .then(response => {
            const memberships = Array.isArray(response.data.data) ? response.data.data : []
            commit('SET_MEMBERSHIPS', memberships)
            const hasActive = memberships.some(m =>
              m.end_date == null || new Date() < new Date(m.end_date)
            )
            posthog.setPersonProperties({ has_active_membership: hasActive })
            resolve()
          })
          .catch(error => {
            commit('SET_MEMBERSHIPS', [])
            reject(error)
          })
      })
    },

    cancelMemberships ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        UserService.cancelMembership().then(() => {
          // this.memberships =res.data.data
          // console.log(res)
          dispatch('getMemberships')
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },

    deleteUser ({ commit, dispatch }) {

      console.log('Doing the delete user action');
      return new Promise((resolve, reject) => {


        UserService.deleteUser().then(response => {


          console.log({ response })

          // this.$store.commit('AUTH_LOGOUT')
          // this.$store.dispatch('logout');
          dispatch('logout')

          // this.memberships =res.data.data
          // console.log(response)
          // dispatch('getMemberships')
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },

    // Keeps the full-screen preloader in App.vue up until `promise` settles,
    // so a page can finish loading its own content before it is revealed.
    // Capped so a hanging request can never leave the spinner up for good.
    holdPreloader ({ commit }, promise) {
      commit('PAGE_LOAD_START')
      const cap = new Promise(resolve => setTimeout(resolve, 10000))
      return Promise.race([Promise.resolve(promise).catch(() => {}), cap])
        .then(() => commit('PAGE_LOAD_END'))
    },

    // Resolves once we know whether the visitor is logged in, which ads they
    // have, their filters and memberships. Never rejects: a guest simply ends
    // up with user === false.
    initSession ({ dispatch }) {
      if (!sessionReady) {
        sessionReady = dispatch('getMe')
          .then(() => Promise.all([
            dispatch('getMyAds').catch(() => {}),
            dispatch('getFilters'),
            dispatch('getMemberships').catch(() => {})
          ]))
          .catch(() => {
            // Not logged in (401) or network error — handled in getMe's catch.
          })
      }
      return sessionReady
    },

    getMyAds ({ commit }) {
      return new Promise((resolve, reject) => {
        AdService.myAds()
          .then(response => {
            commit('SET_MY_ADS', response.data.data)
            resolve()
          })
          .catch(error => {
            commit('SET_MY_ADS', [])
            reject(error)
          })
      })
    },
    setUser ({ commit }, user) {
      return new Promise(resolve => {
        commit('SET_USER', user)
        resolve()
      })
    },
    logout ({ commit }) {
      return new Promise(resolve => {
        let restored = false

        UserService.logout().then(resp => {
          // After "Logga in som" (admin tools) the server puts the admin's own session back
          // instead of logging out: start the app again as the admin.
          if (resp && resp.data && resp.data.restored) {
            restored = true
            window.location.assign('/')
            return
          }
          commit('AUTH_LOGOUT')
          // commit('SET_USER', false)
          // if(FB){
          //   FB.getLoginStatus(function(response) {
          //     if (response.status === 'connected') {
          //       FB.logout(function(response) {
          //         // this part just clears the $_SESSION var
          //         // replace with your own code
          //         // console.log('Loggade ut med FB från Store')
          //         commit('SET_FB_CONNETED', false)
          //       })
          //     }
          //   })
          // }
          // commit('SET_FB_CONNETED', false)
          // router.push({ name: 'login' }).catch(err => {

          //   // console.log(err)
          // })

        }).catch(err => {
          // console.log('Error in logout action:', err)
          commit('AUTH_LOGOUT')
           
        }).finally(() => {
          if (restored) return resolve()
          commit('swaps/RESET_ALL')
          posthog.reset()
          router.push({ name: 'login' }).catch(err => {
            console.log(err)
          })
          resolve()
        })
      })
    },
    login ({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST')
        axios({
          url: this.state.apiBase + '/../../auth/',
          data: user,
          method: 'POST',
          withCredentials: true // Allow cookies
        })
          .then(resp => {
            const token = resp.data.data.token
            commit('AUTH_SUCCESS', token)
            dispatch('getMe').catch(() => {})
            dispatch('getFilters')
            dispatch('getMyAds').catch(() => {})
            dispatch('getMemberships').catch(() => {})
            resolve(resp)
          })
          .catch(err => {
            // console.log('Fel')
            // console.log(err)
            commit('AUTH_ERROR', err)
            // commit('AUTH_LOGOUT')
            storage.removeItem('token')
            reject(err)
          })
      })
    },

    // loginFB({ commit, dispatch }, fbtoken) {
    //   return new Promise((resolve, reject) => {
    //     commit('AUTH_REQUEST')
    //     axios({
    //       url: this.state.apiBase + '/../../fb-auth',
    //       params: { access_token: fbtoken },
    //       // data: user,
    //       method: 'GET'
    //     })
    //       .then(resp => {
    //         // console.log('Logged in')
    //         // console.log(resp.data)
    //         const token = resp.data.data.token
    //         commit('AUTH_SUCCESS', token)
    //         dispatch('getMe')
    //         dispatch('getFilters')
    //         dispatch('getMyAds')
    //         dispatch('getMemberships')
    //         resolve(resp)
    //       })
    //       .catch(err => {
    //         // console.log('Fel')
    //         // console.log(err)
    //         commit('AUTH_ERROR', err)
    //         // commit('AUTH_LOGOUT')
    //         localStorage.removeItem('token')
    //         reject(err)
    //       })
    //   })
    // },

    newPW ({ commit, dispatch }, codeAndEmail) {
      return new Promise((resolve, reject) => {
        // console.log(codeAndEmail)
        // resolve(codeAndEmail)
        axios({
          url: this.state.apiBase + '/newpw',
          data: codeAndEmail,
          method: 'POST'
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    resetpw ({ commit, dispatch }, email) {
      return new Promise((resolve, reject) => {
        // commit('AUTH_REQUEST')
        axios({
          url: this.state.apiBase + '/resetpw',
          data: email,
          method: 'POST'
        })
          .then(resp => {
            // commit('AUTH_SUCCESS', token)
            // dispatch('getMe')
            // dispatch('getFilters')
            // dispatch('getMyAds')
            // console.log(resp)
            resolve(resp)
          })
          .catch(err => {
            // console.log('Fel')
            // console.log(err)
            // commit('AUTH_ERROR', err)
            // commit('AUTH_LOGOUT')
            // localStorage.removeItem('token')
            reject(err)
          })
      })
    },

    registerEmail ({ commit, dispatch }, email) {

      const ref = getCookie('referer');
      if (ref) {
        commit('SET_REFERER', ref)
      } else {
        commit('SET_REFERER', '')
      }


      console.log('Store registering ', email, this.state.referer)
      return new Promise((resolve, reject) => {
        console.log('Store registering inside promise ', email, this.state.referer)
        console.log('URL: ', this.state.apiBase + '/registeremail')
        // commit('AUTH_REQUEST')
        axios({
          url: this.state.apiBase + '/registeremail',
          data: { email, referer: this.state.referer },
          method: 'POST',
          withCredentials: true
        })
          .then(resp => {
            // commit('AUTH_SUCCESS', token)
            // dispatch('getMe')
            // dispatch('getFilters')
            // dispatch('getMyAds')
            // console.log('Register success')
            // console.log(resp.data.data)
            const token = resp.data.data.token
            commit('AUTH_SUCCESS', token)
            // commit('AUTH_SUCCESS', token)
            dispatch('getMe')
            dispatch('getFilters')
            dispatch('getMyAds')
            dispatch('getMemberships')
            resolve(resp.data.data)

            // resolve(resp)
          })
          .catch(err => {
            // console.log('Fel
            console.log('Register fail')
            console.log(err)
            // commit('AUTH_ERROR', err)
            // commit('AUTH_LOGOUT')
            // localStorage.removeItem('token')
            reject(err)
          })
      })
    },

    getMe ({ commit }) {
      return new Promise((resolve, reject) => {
        UserService.getMe()
          .then(response => {
            const userData = response.data.data
            if (!userData) {
              commit('AUTH_LOGOUT')
              return reject(new Error('getMe returned empty user data'))
            }
            commit('SET_USER', userData)
            storage.removeItem('token')
            storage.setItem('me', JSON.stringify(userData))
            Sentry.configureScope(function (scope) {
              scope.setUser({ 'email': userData.email })
            })
            posthog.identify(String(userData.id), {
              email: userData.email,
              firstname: userData.firstname,
              lastname: userData.lastname,
            })
            resolve(userData)
          })
          .catch(error => {
            commit('AUTH_LOGOUT')
            // 401 means not logged in — expected for guests, not a real error
            if (!error || !error.response || error.response.status !== 401) {
              Sentry.captureException(error)
              posthog.captureException(error)
            }
            reject(error)
          })
      })
    },

    setFilters ({ commit }, filters) {
      return new Promise((resolve, reject) => {
        UserService.updateFilters(filters)
          .then(response => {
            commit('SET_FILTERS', response.data.data)
            // dispatch('updateProspects')
            resolve()
          })
          .catch(error => {
            Sentry.captureException(error)
            posthog.captureException(error)
            reject(error)
          })
      })
    },

    updateMe ({ commit }, user) {
      return new Promise((resolve, reject) => {
        UserService.updateMe(user)
          .then(response => {
            // commit('SET_USER', response.data.data)
            resolve()
          })
          .catch(error => {
            Sentry.captureException(error)
            posthog.captureException(error)
            reject(error)
          })
      })
    },

    getLocations ({ commit }) {
  return UserService.getLocations()
    .then(response => {
      commit('SET_LOCATIONS', response.data.data)
      return response.data.data // Optional: return the data
    })
    .catch(error => {
      Sentry.captureException(error);
      throw error // Re-throw so caller knows it failed
    })
},


    getFilters ({ commit }) {
      commit('SET_FILTERS_LOADING', true)
      return UserService.getFilters()
        .then(response => {
          commit(
            'SET_FILTERS',
            response.data.data // .map(p => (p.isShowing = true))
          )
        })
        .catch(error => {
          Sentry.captureException(error);
        }).finally(() => {
            commit('SET_FILTERS_LOADING', false)
        })
    },

    getMatches ({ commit }, adId) {
      if (!adId) {
        return Promise.resolve()
      }
      return new Promise((resolve, reject) => {
        AdService.getMatches(adId)
          .then(response => {
            commit(
              'SET_MATCHES',
              response.data.data // .map(p => (p.isShowing = true))
            )
            // console.log(response.data.data)
            resolve()
          })
          .catch(error => {
            Sentry.captureException(error)
            posthog.captureException(error)
            reject(error)
          })
      })
    },
    getFrontpage ({ commit }) {
      return new Promise((resolve, reject) => {
        AdService.getFrontpage()
          .then(response => {

            // console.log('Frontpage response', response.data.data)
            commit(
              'SET_FRONTPAGE',
              response.data.data // .map(p => (p.isShowing = true))
            )
            // console.log(response.data.data)
            resolve()
          })
          .catch(error => {
            Sentry.captureException(error)
            posthog.captureException(error)
            reject(error)
          })
      })
    },

    getHistory ({ commit }, adId) {
      return new Promise((resolve, reject) => {
        AdService.getHistory(adId)
          .then(response => {
            commit(
              'SET_HISTORY',
              response.data.data.map((x) => {
                return {
                  id: x[0],
                  interest: x[1],
                  rooms: x[2],
                  size: x[3],
                  rent: x[4],
                  city: x[5],
                  address: x[6],
                  image: x[7],
                }
              }) // .map(p => (p.isShowing = true))
            )
            // console.log(response.data.data)
            resolve()
          })
          .catch(error => {
            Sentry.captureException(error)
            posthog.captureException(error)
            reject(error)
          })
      })
    },

    updateProspects ({ commit }) {
      return new Promise((resolve, reject) => {
        // commit('SET_PROSPECTS', [])
        // console.log('updateProspects in store is setting the loading to true')
        // commit('SET_PROSPECTS_LOADING', true)
        AdService.getProspects()
          .then(response => {
            if (response.data.data.length < 1) {
              commit('OUT_OF_MATCHES', true)
            } else {
              commit('OUT_OF_MATCHES', false)
            }
            commit(
              'SET_PROSPECTS',
              response.data.data // .map(p => (p.isShowing = true))
            )
            resolve()
          })
          .catch(error => {
            // console.log('There was an error:', error.response)

            reject(error.response)
          })
      })
    },


    loadMoreProspects ({ commit, state }) {
  return new Promise((resolve, reject) => {
    AdService.getProspects()
      .then(response => {
        // Append the new prospects first
        commit('APPEND_PROSPECTS', response.data.data)
        
        // Check OUT_OF_MATCHES based on total prospects after appending
        if (state.prospects.length < 1) {
          commit('OUT_OF_MATCHES', true)
        } else {
          commit('OUT_OF_MATCHES', false)
        }
        
        resolve()
      })
      .catch(error => {
        reject(error.response)
      })
  })
}

  },
  getters: {

    // Add this to your getters object in the store

dominantCity: (state) => {
  if (!state.filters || !state.filters.locationIds || state.filters.locationIds.length === 0) {
    return null;
  }

  // Define the top-level city IDs and their parent paths
  const cityRoots = {
    'stockholm': 1,
    'goteborg': 68,
    'malmo': 104
  };

  // Helper function to check if a location ID is within a city's tree
  function isInCityTree(locationId, cityRootId, locations) {
    // First check if the locationId IS the city root
    if (locationId === cityRootId) {
      return true;
    }

    // For Malmö, we need to find it under Skåne (id: 3)
    if (cityRootId === 104) {
      const skane = locations.find(loc => loc.id === 3);
      if (skane && skane.children) {
        const malmo = skane.children.find(child => child.id === 104);
        if (malmo) {
          return searchInNode(malmo, locationId);
        }
      }
      return false;
    }

    // For Stockholm and Göteborg, search from their root
    const cityRoot = locations.find(loc => loc.id === cityRootId);
    if (cityRoot) {
      return searchInNode(cityRoot, locationId);
    }
    
    return false;
  }

  // Recursive search within a node and its children
  function searchInNode(node, targetId) {
    if (node.id === targetId) {
      return true;
    }
    if (node.children) {
      return node.children.some(child => searchInNode(child, targetId));
    }
    return false;
  }

  // Count how many selected locations belong to each city
  const cityCounts = {
    'stockholm': 0,
    'goteborg': 0,
    'malmo': 0
  };

  // Count each selected location
  state.filters.locationIds.forEach(locationId => {
    Object.entries(cityRoots).forEach(([cityName, cityId]) => {
      if (isInCityTree(locationId, cityId, state.locations)) {
        cityCounts[cityName]++;
      }
    });
  });

  // Find the city with the most locations
  let dominantCity = null;
  let maxCount = 0;

  Object.entries(cityCounts).forEach(([cityName, count]) => {
    if (count > maxCount) {
      maxCount = count;
      dominantCity = cityName;
    }
  });

  return dominantCity;
},
      getGeoJsonById: (state) => (id) => {
    return state.geojsons[id] || null;
  },
  
  getGeoJsonsByIds: (state) => (ids) => {
    return ids.map(id => state.geojsons[id]).filter(Boolean);
  },
  
  hasGeoJson: (state) => (id) => {
    return !!state.geojsons[id];
  },
  
  isGeoJsonsLoading: (state) => state.geojsonsLoading,

    getLocationById: (state) => (id) => {
    const findLocation = (locations, targetId) => {
      for (const location of locations) {
        if (location.id === targetId) {
          return location;
        }
        if (location.children) {
          const found = findLocation(location.children, targetId);
          if (found) return found;
        }
      }
      return null;
    };
    
    return findLocation(state.locations, id);
  },
    showMoreMenu: state => {
      return state.showMoreMenu
    },
    outOfMatches: state => {
      return state.outOfMatches
    },
    locations: state => {
      return state.locations
    },
    getIdsWithDescendants: (state) => (targetIds) => {
      return getIdsWithDescendants(state.locations, targetIds);
    },
   selectedLocationsAndTheirChildren: (state) => {
  
      if (!state.filters || !state.filters.locationIds) {
        // console.log('No filters or locationIds found');
        return []
      }
      // console.log('Looking for location IDs:', state.filters.locationIds);

      const allIds = getIdsWithDescendants(state.locations, state.filters.locationIds);
      // console.log('All selected location IDs including descendants:', allIds);
      return allIds;
    },
    memberships: state => {
      return state.memberships
    },
    activeMemberships: state => {
      // membershipIsActive(membership){
      //   return membership.end_date == null || new Date() < new Date(membership.end_date)
      // },
      // return state.memberships
      return state.memberships ? state.memberships.filter(membership => membership.end_date == null || new Date() < new Date(membership.end_date)) : []
    },
    matches: state => {
      return state.matches
    },
    history: state => {
      return state.history
    },
    fbFirstName: state => {
      return state.fbFirstName
    },
    fbRefused: state => {
      return state.fbRefused
    },
    fbConnected: state => {
      return state.fbConnected
    },
    fbSdkReady: state => {
      return state.fbSdkReady
    },
    adDetails: state => {
      return state.adDetails
    },
    prospectModal: state => {
      return state.prospectModal
    },
    prospectsPhotos: state => {
      return state.prospects.map(ad => ad.photo)
    },
    pageLoading: state => {
      return state.pageLoads > 0
    },
    prospectsLoading: state => {
      return state.prospectsLoading
    },
    myAds: state => {
      return state.myAds
    },
    frontPage: state => {
      return state.frontPage
    },

    myActiveAd: state => {
      if (state.myAds && state.myAds.length > 0) {
        return state.myAds[0].id
      } else {
        return false
      }
    },
    hasAds: state => {
      if (state.myAds && state.myAds.length > 0) {
        return true
      } else {
        return false
      }
    },
    loginstatus: state => {
      return state.loginstatus
    },
    showFilters: state => {
      return state.showFilters
    },
    apiBase: state => {
      return state.apiBase
    },
    token: state => {
      return state.token
    },
    catLength: state => {
      return state.categories.length
    },
    prospects: state => {
      return state.prospects
    },
    currentAd: state => {
      return state.prospects[0]
    },
    listenToKeyboard: state => {
      return state.listenToKeyboard
    },
    user: state => {
      return state.user
    },
    filters: state => {
      return state.filters
    }
  }
})


// Function to get a cookie by name
function getCookie (name) {
  const nameEQ = name + "=";
  const cookiesArray = document.cookie.split(';');
  for (let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

function getIdsWithDescendants(data, targetIds) {
  const result = new Set(targetIds);
  
  function collectDescendants(node) {
    if (targetIds.includes(node.id)) {
      addAllDescendants(node);
    }
    if (node.children) {
      node.children.forEach(collectDescendants);
    }
  }
  
  function addAllDescendants(node) {
    result.add(node.id);
    if (node.children) {
      node.children.forEach(addAllDescendants);
    }
  }
  
  data.forEach(collectDescendants);
  
  return Array.from(result);
}
